export default {
      id: "photo-crop-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "sprite-46b249.svg#photo-crop-usage",
      toString: function () {
        return this.url;
      }
    }